import { ReactNode, useState } from 'react';
import './TeamShell.css';

export type TeamTab = 'licensing' | 'foreign-dns' | 'sequencer' | 'domain-contests';

interface TeamShellProps {
  children: ReactNode;
  onSignOut: () => void;
  tab: TeamTab;
  onTabChange: (tab: TeamTab) => void;
}

export function TeamShell({ children, onSignOut, tab, onTabChange }: TeamShellProps): JSX.Element {
  const [signingOut, setSigningOut] = useState(false);

  const handleSignOut = async (): Promise<void> => {
    setSigningOut(true);
    try {
      await fetch('/api/team/logout', { method: 'POST' });
    } catch {
      // ignore — we're tearing down anyway
    } finally {
      onSignOut();
    }
  };

  return (
    <div className="team-shell">
      <header className="team-shell-header">
        <div className="team-shell-brand">
          <div className="team-shell-logo">AP</div>
          <div className="team-shell-titles">
            <span className="team-shell-product">Admin Panel</span>
            <span className="team-shell-context">Team</span>
          </div>
        </div>
        <nav className="team-tabs" aria-label="Team sections">
          <button
            type="button"
            className={`team-tab ${tab === 'licensing' ? 'team-tab--active' : ''}`}
            onClick={() => onTabChange('licensing')}
          >
            Licensing
          </button>
          <button
            type="button"
            className={`team-tab ${tab === 'foreign-dns' ? 'team-tab--active' : ''}`}
            onClick={() => onTabChange('foreign-dns')}
          >
            Foreign CF DNS
          </button>
          <button
            type="button"
            className={`team-tab ${tab === 'sequencer' ? 'team-tab--active' : ''}`}
            onClick={() => onTabChange('sequencer')}
          >
            Sequencer Connect
          </button>
          <button
            type="button"
            className={`team-tab ${tab === 'domain-contests' ? 'team-tab--active' : ''}`}
            onClick={() => onTabChange('domain-contests')}
          >
            Domain Contests
          </button>
        </nav>
        <button
          type="button"
          className="team-shell-signout"
          onClick={() => void handleSignOut()}
          disabled={signingOut}
        >
          {signingOut ? 'Signing out…' : 'Sign out'}
        </button>
      </header>
      <main className="team-shell-main">{children}</main>
    </div>
  );
}
